export const supportedQuickCreateObjects = {
    contacts: {
      label: 'Contact',
      splitSpaces: true,
      fields: [
        // {name: 'title', type: 'text', placeholder: 'e.g.CEO'},
        {
            name: 'first_name',
            type: 'text',
            placeholder: 'e.g. Marsha',
            showRequired: (object) => !object.company_name && !object.first_name,
            config: {
                validate: (value, object) => {
                    if (!value && !object.company_name) return 'Required if Company is blank';
                    return true;
                },
            },
        },
        {name: 'last_name', type: 'text', placeholder: 'e.g. MainStreet'},
        {
            name: 'company_name',
            label: 'Company',
            type: 'text',
            placeholder: 'e.g. Marsha\'s Truffles',
            showRequired: (object) => !object.company_name && !object.first_name,
            config: {
                validate: (value, object) => {
                    if (!value && !object.first_name) return 'Required if First Name is blank';
                    return true;
                },
            },
        },
        {name: 'email', type: 'text', placeholder: 'e.g. marsha@tastytruffles.net'},
    ]
  },
  'work-plans': {
    label: 'Work Plan',
    fields: [
      {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. 2024 Clean Up Day',
        showRequired: true,
        config: {
            required: true,
        }
      },
      {name: 'workplan_date', label: 'Date', type: 'date', placeholder: 'e.g. 05/23/2016'},
    ],
  },
  businesses: {
    label: 'Business',
    fields: [
      {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. Marsha\'s Truffles',
        showRequired: true,
        config: {
            required: true,
        }
      },
      {name: 'phone', type: 'text', placeholder: 'e.g. (000) 000-0000'},
    ],
  },
  properties: {
    label: 'Property',
    fields: [
      {
        name: 'address',
        type: 'text',
        placeholder: 'e.g. 123 Main Street',
        showRequired: true,
        config: {
            required: true,
        }
      },
    ],
  },
  events: {
    label: 'Event',
    fields: [
      {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. Trufflefest',
        showRequired: true,
        config: {
            required: true,
        },
      },
      {
          name: 'event_category_id',
          label: 'Category',
          type: 'relationship',
          endpoint: 'event-categories',
          defaultProp: 'event_category',
          loadAll: true,
      },
      {name: 'location', type: 'text', placeholder: 'e.g. Conductor Park'},
    ],
  },
  involvements: {
    label: 'Involvement',
    fields: [
      {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. Visionary Partner',
        showRequired: true,
        config: {
            required: true,
        },
      },
      {
        name: 'description',
        type: 'text',
        placeholder: 'e.g. 7500 (4 Available)',
      },
      {
        name: 'category_id',
        label: 'Category',
        type: 'relationship',
        endpoint: 'involvement-categories',
        // defaultProp: 'event_category',
        loadAll: true,
      },
    ],
  },
  'involvement-categories': {
    label: 'Involvement Category',
    fields: [
      {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. Doner',
        showRequired: true,
        config: {
            required: true,
        },
      },
      {
        name: 'description',
        type: 'text',
        placeholder: 'e.g. Person or Business that gave money to a project',
      },
    ],
  },
};
